import { lazy } from 'react'

export const ProfileHeader =  lazy(() => import('./ProfileHeader'))
export const FavouriteItem =  lazy(() => import('./FavouriteItem'))
export const SportItems =  lazy(() => import('./SportItems'))
export const ProfileCommonInfo =  lazy(() => import('./ProfileCommonInfo'))
export const FavouritesModal =  lazy(() => import('./FavouritesModal'))
export const ProfileShareLink =  lazy(() => import('./ProfileShareLink'))
